webpackJsonp([8],{

/***/ 1067:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmVoucher_vue__ = __webpack_require__(1122);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7163ad95_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmVoucher_vue__ = __webpack_require__(1220);
function injectStyle (ssrContext) {
  __webpack_require__(1218)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmVoucher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7163ad95_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmVoucher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/myticketi.4ef8247.png";

/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Printd = exports.createIFrame = exports.createLinkStyle = exports.createStyle = void 0;
var URL_LONG = /^(((http[s]?)|file):)?(\/\/)+([0-9a-zA-Z-_.=?&].+)$/;
var URL_SHORT = /^((\.|\.\.)?\/)([0-9a-zA-Z-_.=?&]+\/)*([0-9a-zA-Z-_.=?&]+)$/;
var isValidURL = function (str) { return URL_LONG.test(str) || URL_SHORT.test(str); };
function createStyle(doc, cssText) {
    var style = doc.createElement("style");
    style.appendChild(doc.createTextNode(cssText));
    return style;
}
exports.createStyle = createStyle;
function createLinkStyle(doc, url) {
    var style = doc.createElement("link");
    style.type = "text/css";
    style.rel = "stylesheet";
    style.href = url;
    return style;
}
exports.createLinkStyle = createLinkStyle;
function createIFrame(parent) {
    var el = window.document.createElement("iframe");
    el.setAttribute("src", "about:blank");
    el.setAttribute("style", "visibility:hidden;width:0;height:0;position:absolute;z-index:-9999;bottom:0;");
    el.setAttribute("width", "0");
    el.setAttribute("height", "0");
    el.setAttribute("wmode", "opaque");
    parent.appendChild(el);
    return el;
}
exports.createIFrame = createIFrame;
var DEFAULT_OPTIONS = {
    parent: window.document.body,
    headElements: [],
    bodyElements: []
};
/** Printd class that prints HTML elements in a blank document */
var Printd = /** @class */ (function () {
    function Printd(options) {
        this.isLoading = false;
        this.hasEvents = false;
        // IE 11+ "Object.assign" polyfill
        this.opts = [DEFAULT_OPTIONS, options || {}].reduce(function (a, b) {
            Object.keys(b).forEach(function (k) { return (a[k] = b[k]); });
            return a;
        }, {});
        this.iframe = createIFrame(this.opts.parent);
    }
    /** Gets current Iframe reference */
    Printd.prototype.getIFrame = function () {
        return this.iframe;
    };
    /**
     * Print an HTMLElement
     *
     * @param el HTMLElement
     * @param styles Optional styles (css texts or urls) that will add to iframe document.head
     * @param scripts Optional scripts (script texts or urls) that will add to iframe document.body
     * @param callback Optional callback that will be triggered when content is ready to print
     */
    Printd.prototype.print = function (el, styles, scripts, callback) {
        if (this.isLoading)
            return;
        var _a = this.iframe, contentDocument = _a.contentDocument, contentWindow = _a.contentWindow;
        if (!contentDocument || !contentWindow)
            return;
        this.iframe.src = "about:blank";
        this.elCopy = el.cloneNode(true);
        if (!this.elCopy)
            return;
        this.isLoading = true;
        this.callback = callback;
        var doc = contentWindow.document;
        doc.open();
        doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"></head><body></body></html>');
        this.addEvents();
        // 1. append custom elements
        var _b = this.opts, headElements = _b.headElements, bodyElements = _b.bodyElements;
        // 1.1 append custom head elements
        if (Array.isArray(headElements)) {
            headElements.forEach(function (el) { return doc.head.appendChild(el); });
        }
        // 1.1 append custom body elements
        if (Array.isArray(bodyElements)) {
            bodyElements.forEach(function (el) { return doc.body.appendChild(el); });
        }
        // 2. append custom styles
        if (Array.isArray(styles)) {
            styles.forEach(function (value) {
                if (value) {
                    doc.head.appendChild(isValidURL(value) ? createLinkStyle(doc, value) : createStyle(doc, value));
                }
            });
        }
        // 3. append element copy
        doc.body.appendChild(this.elCopy);
        // 4. append custom scripts
        if (Array.isArray(scripts)) {
            scripts.forEach(function (value) {
                if (value) {
                    var script = doc.createElement("script");
                    if (isValidURL(value)) {
                        script.src = value;
                    }
                    else {
                        script.innerText = value;
                    }
                    doc.body.appendChild(script);
                }
            });
        }
        doc.close();
    };
    /**
     * Print an URL
     *
     * @param url URL to print
     * @param callback Optional callback that will be triggered when content is ready to print
     */
    Printd.prototype.printURL = function (url, callback) {
        if (this.isLoading)
            return;
        this.addEvents();
        this.isLoading = true;
        this.callback = callback;
        this.iframe.src = url;
    };
    Printd.prototype.launchPrint = function (contentWindow) {
        if (!this.isLoading) {
            contentWindow.print();
        }
    };
    Printd.prototype.addEvents = function () {
        var _this = this;
        if (!this.hasEvents) {
            this.hasEvents = true;
            this.iframe.addEventListener("load", function () { return _this.onLoad(); }, false);
        }
    };
    Printd.prototype.onLoad = function () {
        var _this = this;
        if (this.iframe) {
            this.isLoading = false;
            var _a = this.iframe, contentDocument = _a.contentDocument, contentWindow_1 = _a.contentWindow;
            if (!contentDocument || !contentWindow_1)
                return;
            if (typeof this.callback === "function") {
                this.callback({
                    iframe: this.iframe,
                    element: this.elCopy,
                    launchPrint: function () { return _this.launchPrint(contentWindow_1); }
                });
            }
            else {
                this.launchPrint(contentWindow_1);
            }
        }
    };
    return Printd;
}());
exports.Printd = Printd;
exports.default = Printd;


/***/ }),

/***/ 1122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_printd__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_printd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_printd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_constant_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_constant_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_constant_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Offers",

    components: {
        Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"]
    },
    data: function data() {
        return {
            reserveId: "",
            token: "",
            project: __WEBPACK_IMPORTED_MODULE_3__helper_constant_js__["PROJECT"],
            finalBookingDetails: {},
            finalBookingID: "",
            BookingPDF: ""
        };
    },
    mounted: function mounted() {
        this.reserveId = this.$route.params.reserveId;
        this.token = this.$route.params.token;
        this.finalBookingID = this.$route.params.bookingId;
        this.getBookingDetails();
    },

    methods: {
        printToFile: function printToFile() {
            var cssText = "\n          .m_ticket {\n    width: 95%;\n    overflow: hidden;\n    display: table;\n    margin: 0 auto;\n    max-width: 375px;\n    border-radius: 15px;\n    border: 1px solid #d3d3d3;\n}\n.ticket_img {\n    height: 165px;\n    overflow: hidden;\n    position: relative;\n}\nimg {\n    vertical-align: middle;\n    border-style: none;\n}\n.ticket_img img {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    -o-object-position: top;\n    object-position: top;\n}\n.m_ticket .movie_details {\n    bottom: 0px;\n    width: 100%;\n    z-index: 111;\n    color: #fff;\n    padding: 8px;\n    position: absolute;\n    letter-spacing: 1px;\n}\n.p-3 {\n    padding: 1rem !important;\n}\n.ticket_img::after {\n    top: 0;\n    left: 0;\n    width: 100%;\n    content: '';\n    height: 100%;\n    display: block;\n    position: absolute;\n    background: -o-linear-gradient(bottom, #000000, #00000054, #ffffff00);\n    background: -webkit-gradient(linear, left bottom, left top, from(#000000), color-stop(#00000054), to(#ffffff00));\n    background: linear-gradient(to top, #000000, #00000054, #ffffff00);\n}\n.d-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n.w-75 {\n    width: 75% !important;\n}\n.userDetail, .print-list, .filter-list, .status-filter, .showtime-list, .selected-seat, .select-seat-list, .movie-details-list, .recent-booking-list, .seat-appearance-list, .showtime-list li ol {\n    padding-left: 0;\n    font-size: 16px;\n    margin-bottom: 0;\n    list-style: none;\n}\n.selected-seat li {\n    display: inline-block;\n}\n.w-25 {\n    width: 25% !important;\n}\n.ml-1, .mx-1 {\n    margin-left: 0.25rem !important;\n}\n.m_ticket h5 {\n    line-height: 1;\n    font-size: 30px;\n    margin-bottom: 0;\n    font-weight: bold;\n}\n.lh-1 {\n    line-height: 1;\n}\n.align-items-center {\n    -ms-flex-align: center !important;\n    align-items: center !important;\n}\nhr {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n.selected-seat li:nth-last-child(1)::after {\n    content: '';\n}\n.qrDetails {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.mb-2, .my-2 {\n    margin-bottom: 0.5rem !important;\n}\n.text-muted {\n    color: #6c757d !important;\n}\nsmall, .small {\n    font-size: 80%;\n    font-weight: 400;\n}\n.fs-20 {\n    font-size: 20px;\n}\n.font-weight-bold {\n    font-weight: 700 !important;\n}\n.w-50 {\n    width: 50% !important;\n}\n._title {\n    color: grey;\n    line-height: 1;\n    margin-bottom: 5px;\n}\n.position-relative{\n  position: relative;\n}\n.ticket-date-box {\n   \n}\n\n\n.ticket-date-content {\n  position: absolute;\n  top: 0;\n  left: 30px;\n}\n      ";
            var d = new __WEBPACK_IMPORTED_MODULE_2_printd__["Printd"]();
            d.print(document.getElementById("ticket"), [cssText]);
        },

        getBookingDetails: function getBookingDetails() {
            var _this = this;

            var payload = {
                PurchaseID: this.finalBookingID
            };

            Object(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__["makeRequest"])("/GetVoucherDetails", "POST", null, payload).then(function (result) {
                var error = result.error,
                    res = result.res;

                if (!error) {
                    _this.finalBookingDetails = res.data;
                    if (_this.project == "ticketak") {
                        _this.BookingPDF = "https://api.ticketak.com/shareticket/" + _this.finalBookingDetails.BookingID + ".pdf";
                    } else {
                        _this.BookingPDF = "https://api.mytiketi.com/shareticket/" + _this.finalBookingDetails.BookingID + ".pdf";
                    }
                    var IHC = window.localStorage.getItem("IHC");
                    var sku = window.localStorage.getItem("sku");
                    var STP = window.localStorage.getItem("STP");
                    var obj = {
                        transactionId: _this.finalBookingID,
                        transactionAffiliation: _this.finalBookingDetails.CinemaName,
                        transactionTotal: Number(_this.finalBookingDetails.Total),
                        transcationDate: _this.finalBookingDetails.MovieDateDate + " " + _this.finalBookingDetails.MovieDateMonth + " " + _this.finalBookingDetails.MovieDateDay + " " + _this.finalBookingDetails.MovieTimingTime,
                        transactionTax: Number(IHC),
                        transactionProducts: [{
                            sku: sku,
                            name: _this.finalBookingDetails.Title,
                            price: STP,
                            quantity: _this.finalBookingDetails.SeatsBooked
                        }]
                    };
                    console.log("obj :", obj);
                    // this.$gtm.push(obj);
                    //this.$gtm.trackEvent(obj);
                    console.log("ga :", ga);
                    ga("send", "event", "Videos", "play", "Fall Campaign");
                } else {
                    console.log("error from res", res.message);
                }
            }).catch(function (error) {
                console.log("Error on vue front", error);
            });
        }
    }
});

/***/ }),

/***/ 1218:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1219);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1039)("41ca83fb", content, true, {});

/***/ }),

/***/ 1219:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1038)(true);
// imports


// module
exports.push([module.i, ".fs-20{font-size:20px}.ticket-date-box{height:30px;width:30px;display:block}.ticket-date-content{position:absolute;top:0;left:30px}", "", {"version":3,"sources":["/var/www/html/wanasa/website/vue-pwa-initial-setup/src/components/pages/ConfirmVoucher.vue"],"names":[],"mappings":"AACA,OACE,cAAgB,CACjB,AACD,iBACE,YAAa,AACb,WAAY,AACZ,aAAe,CAChB,AAED,qBACE,kBAAmB,AACnB,MAAO,AACP,SAAW,CACZ","file":"ConfirmVoucher.vue","sourcesContent":["\n.fs-20 {\n  font-size: 20px;\n}\n.ticket-date-box {\n  height: 30px;\n  width: 30px;\n  display: block;\n}\n/* .ticket-date-box  */\n.ticket-date-content {\n  position: absolute;\n  top: 0;\n  left: 30px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"wrapper mb-5 py-4"},[_c('div',{staticClass:"mx-auto d-table"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"wrapper d-none d-md-block",staticStyle:{"padding-top":"40px"}},[_c('div',{staticClass:"final_ticket_new"},[_c('div',{staticClass:"row mx-0"},[_c('div',{staticClass:"col-3 px-0 bg-grey cinemas-logo"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.finalBookingDetails.HeaderImage,"alt":""}}),_vm._v(" "),(_vm.project == 'ticketak')?_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.finalBookingDetails.CinemaLogo,"height":"50px","width":"100px","alt":""}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6 py-2 bg-grey"},[_c('div',{staticClass:"ticket_content"},[_c('div',{staticClass:"_title"},[_vm._v("Cinema")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.finalBookingDetails.OrgName))]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.finalBookingDetails.VoucherText))])]),_vm._v(" "),_c('hr',{staticClass:"my-2"}),_vm._v(" "),_c('div',{staticClass:"_title"},[_vm._v("Voucher Code")]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.finalBookingDetails.VoucherCode))]),_vm._v(" "),_c('div',{staticClass:"row mx-0"},[_c('div',{staticClass:"col-8 px-0"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.finalBookingDetails.NoofVouchers))])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 px-0"},[_c('div',{staticClass:"_title"},[_vm._v("Date of Purchase")]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('span',[_vm._v(_vm._s(_vm.finalBookingDetails.DateOfPurchase))])])])]),_vm._v(" "),_c('hr',{staticClass:"my-2"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between mb-3"},[_c('div',[_vm._v("Total Amount")]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.finalBookingDetails.Currency)+" "+_vm._s(_vm.finalBookingDetails.Total))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticStyle:{"position":"absolute","bottom":"0"}},[_vm._v("\n                    *Validity & use of voucher subject to\n                    "),_c('router-link',{staticClass:"text-blue",attrs:{"target":"_blank","to":"/tnc"}},[_vm._v("\n                       \n                      "),_c('u',[_vm._v("Terms & Conditions")])]),_vm._v(".\n                  ")],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-3 px-0 d-flex flex-column border-left-dashed bg-grey"},[_c('div',{staticClass:"qrDetails mt-3"},[(_vm.project == 'ticketak')?_c('img',{staticClass:"w-75 mb-2",attrs:{"src":_vm.finalBookingDetails.QRCode,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',[(_vm.project == 'ticketak')?_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(1221),"alt":""}}):_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(1082),"alt":""}})])])])])]),_vm._v(" "),_c('section',{staticClass:"d-md-none mb-2",attrs:{"id":"ticket"}},[_c('div',{staticClass:"m_ticket"},[_c('div',{staticClass:"ticket_img"},[_c('img',{attrs:{"src":_vm.finalBookingDetails.HeaderImageMobile}}),_vm._v(" "),_c('div',{staticClass:"movie_details p-3"},[_c('div',{staticClass:"movie_title"},[_vm._v(_vm._s(_vm.finalBookingDetails.OrgName))]),_vm._v(" "),_c('div',{staticClass:"small"},[_c('span',[_vm._v(_vm._s(_vm.finalBookingDetails.VoucherText))])])])]),_vm._v(" "),_c('div',{staticClass:"p-3"},[_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"_title w-50"},[_vm._v("Date of Purchase")]),_vm._v(" "),_c('div',{staticClass:"w-50"},[_vm._v(_vm._s(_vm.finalBookingDetails.DateOfPurchase))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('div',{staticClass:"_title"},[_vm._v("Voucher Code")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.finalBookingDetails.VoucherCode))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"w-75"},[_c('div',{staticClass:"_title"},[_vm._v("Tickets to be issued")]),_vm._v(" "),_c('ul',{staticClass:"selected-seat"},[_c('li',[_vm._v(_vm._s(_vm.finalBookingDetails.NoofVouchers))])])]),_vm._v(" "),_c('div',{staticClass:"w-25"},[_c('div',{staticClass:"_title"},[_vm._v("Amount")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.finalBookingDetails.Currency)+" "+_vm._s(_vm.finalBookingDetails.Total))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"qrDetails"},[(_vm.project == 'ticketak')?_c('img',{staticClass:"w-50 mb-2",attrs:{"src":_vm.finalBookingDetails.QRCode,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.project == 'wanasatime')?_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(1082),"width":"100px","alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"fs-11"},[_vm._v("\n                *Validity & use of voucher subject to\n                "),_c('router-link',{staticClass:"text-blue",attrs:{"target":"_blank","to":"/tnc"}},[_vm._v("\n                   \n                  "),_c('u',[_vm._v("Terms & Conditions")])]),_vm._v(".\n              ")],1)])])])]),_vm._v(" "),_c('div',{staticClass:"d-none final_ticket bg-light"},[_c('div',{staticClass:"row mx-0"},[_c('div',{staticClass:"col-md-9 py-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('img',{staticClass:"img-fluid rounded",attrs:{"src":_vm.finalBookingDetails.Image,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-9 pr-4"},[_c('div',[_c('h5',{staticClass:"font-weight-"},[_vm._v(_vm._s(_vm.finalBookingDetails.Title))]),_vm._v(" "),_c('div',{staticClass:"mb-1"},[_c('span',[_vm._v(_vm._s(_vm.finalBookingDetails.Language))]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"format"},[_vm._v(_vm._s(_vm.finalBookingDetails.Format))])]),_vm._v(" "),_c('div',{staticClass:"mb-1"},[_c('span',[_vm._v(_vm._s(_vm.finalBookingDetails.MovieTiming))]),_vm._v(" "),_c('span',{staticClass:"mx-1"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.finalBookingDetails.MovieDate))])]),_vm._v(" "),_c('div',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.finalBookingDetails.CinemaName)+" "+_vm._s(_vm.finalBookingDetails.Address))]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("\n                    Seats\n                    "),_c('span',{staticClass:"font-weight-bold"},[_vm._v("("+_vm._s(_vm.finalBookingDetails.SeatsBooked)+")")])]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"list-inline mb-0 small"},[_c('li',{staticClass:"list-inline-item mr-1"},[_vm._v(_vm._s(_vm.finalBookingDetails.SeatsList))])])])]),_vm._v(" "),_c('hr',{staticClass:"my-2"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-4 text-right small"},[_c('div',[_vm._v(_vm._s(_vm.finalBookingDetails.Currency)+" "+_vm._s(_vm.finalBookingDetails.Total))])])]),_vm._v(" "),_c('div',{staticClass:"my-1",staticStyle:{"border-top":"1px dashed grey"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 font-weight-bold"},[_vm._v("Amount Paid")]),_vm._v(" "),_c('div',{staticClass:"col-4 text-right font-weight-bold"},[_vm._v(_vm._s(_vm.finalBookingDetails.Currency)+" "+_vm._s(_vm.finalBookingDetails.Total))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 d-flex flex-column justify-content-center py-3",staticStyle:{"border-left":"1px dashed grey"}},[_c('div',{staticClass:"qrDetails"},[(_vm.project == 'ticketak')?_c('img',{staticClass:"w-50 mb-2",attrs:{"src":__webpack_require__(554),"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("BOOKING ID")]),_vm._v(" "),_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.finalBookingDetails.ReceiptNo))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"d-none"},[_c('a',{staticClass:"btn-print",attrs:{"href":_vm.BookingPDF,"target":"_blank"}},[_vm._v("Print")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-success mt-5"},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Thank you for your purchase")]),_vm._v(" "),_c('div',[_vm._v("We will send you an e-mail & SMS confirmation within 15 minutes.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_title"},[_c('strong',[_vm._v("Tickets to be issued")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"d-flex align-items-center w-75 position-relative"}),_vm._v(" "),_c('div',{staticClass:"d-flex"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-8 small"},[_c('div',[_vm._v("Ticket Price")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1221:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tt-logo_color.ccd5927.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.8ff721a775d795e9fb14.js